// extracted by mini-css-extract-plugin
export var hidden = "_ve-0";